import L from "leaflet"
import "leaflet-gesture-handling"

// leaflet.markercluster is a UMD bundle that looks for L on globalThis at evaluation
// time. Exposing it here lets any controller that imports this module first satisfy
// that lookup without requiring a global inject in vite.config.
globalThis.L = L

export const TILES = {
  street: {
    label: "Street",
    url:   "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
    attrib: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/">CARTO</a>',
  },
  light: {
    label: "Light",
    url:   "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
    attrib: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/">CARTO</a>',
  },
  dark: {
    label: "Dark",
    url:   "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png",
    attrib: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/">CARTO</a>',
  },
  satellite: {
    label: "Satellite",
    url:   "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    attrib: "Tiles &copy; Esri &mdash; Source: Esri, USGS",
    maxZoom: 19,
  },
}

// Swap the active TileLayer on a map instance
export function applyTile(map, key) {
  const t = TILES[key]
  if (!t) return
  map.eachLayer(l => { if (l instanceof L.TileLayer) l.remove() })
  L.tileLayer(t.url, { attribution: t.attrib, maxZoom: t.maxZoom ?? 19 }).addTo(map)
}

// Create and attach a collapsible tile-picker control to a Leaflet map
export function addTileControl(map, defaultKey = "street") {
  applyTile(map, defaultKey)

  const ctrl = L.control({ position: "topright" })
  ctrl.onAdd = () => {
    const wrap = L.DomUtil.create("div", "lf-tile-ctrl")

    const setToggleIcon = key =>
      toggle.innerHTML = `<span class="lf-tile-swatch lf-tile-swatch--${key}"></span>`

    // Toggle button
    const toggle = L.DomUtil.create("button", "lf-tile-toggle", wrap)
    toggle.type = "button"
    toggle.title = "Switch map style"
    setToggleIcon(defaultKey)

    // Options panel (hidden by default)
    const panel = L.DomUtil.create("div", "lf-tile-panel", wrap)

    Object.entries(TILES).forEach(([key, tile]) => {
      const btn = L.DomUtil.create("button", "lf-tile-btn", panel)
      btn.type = "button"
      btn.dataset.tileKey = key
      btn.innerHTML = `<span class="lf-tile-swatch lf-tile-swatch--${key}"></span>${tile.label}`
      if (key === defaultKey) btn.classList.add("lf-tile-btn--active")

      L.DomEvent.on(btn, "click", e => {
        L.DomEvent.stopPropagation(e)
        applyTile(map, key)
        panel.querySelectorAll(".lf-tile-btn").forEach(b => b.classList.remove("lf-tile-btn--active"))
        btn.classList.add("lf-tile-btn--active")
        setToggleIcon(key)
        wrap.classList.remove("lf-tile-ctrl--open")
      })
    })

    L.DomEvent.on(toggle, "click", e => {
      L.DomEvent.stopPropagation(e)
      wrap.classList.toggle("lf-tile-ctrl--open")
    })

    // Close panel when clicking outside
    L.DomEvent.on(document, "click", () => wrap.classList.remove("lf-tile-ctrl--open"))

    L.DomEvent.disableClickPropagation(wrap)
    L.DomEvent.disableScrollPropagation(wrap)
    return wrap
  }

  ctrl.addTo(map)
  return ctrl
}
